import React from 'react';

export default function CustomToastMessage({ icon, title, description }) {
	return (
		<div
			className="toast show position-fixed top-0 start-50 translate-middle-x m-3 rounded-4 border-0"
			style={{ backgroundColor: 'rgba(243, 255, 235, 1)', zIndex: 999, minWidth: '600px' }}
			role="alert"
		>
			<div className="d-flex justify-content-start align-items-center gap-4 p-3">
				<img
					src={icon}
					alt="icon"
				/>
				<div>
					<div className="fs-4 fw-bold text-dark">{title}</div>
					<div className="fs-5 fw-light text-dark">{description}</div>
				</div>
			</div>
		</div>
	);
}
